<template>
    <b-form @submit.prevent="CalculateSimulation" novalidate>
        <div class="row cpms-row" >
            <div class="col-md-6">
                <common-form></common-form>
                <!--FORM-->
                <div class="form-group row">
                    <label class="col-md-6 col-12">{{ text.chooseCare }}</label>
                    <div class="col-md-6 col-12 text-md-right text-left">
                        <select v-show="!showResults" class="form-control form-control-sm" v-model="selectedSubAct" required>
                            <option v-for="type in subactTypes" v-bind:key="type">{{type}}</option>
                        </select>
                        <p v-show="showResults">{{ selectedSubAct }}</p>
                        <b-form-invalid-feedback :state="showRequiredSubact">
                            {{ text.requiredValueValidationMessage }}
                        </b-form-invalid-feedback>
                    </div>
                </div>
                <div class="form-group row flex-inline">
                    <label class="col-md-8 col-12">{{ text.dailyHospitalFees }}</label>
                    <div class="col-md-3 col-10 text-md-right text-left">
                        <div v-show="!showResults" class="input-group input-group-sm">
                            <b-form-input :state="inputValidation" v-model="amount" type="number" step="0.01" class="form-control" aria-label="Montant de la dépense" required></b-form-input>
                            <div class="input-group-append">
                                <span class="input-group-text">€</span>
                            </div>
                        </div>
                        <p v-show="showResults">{{ amount + " €" }}</p>
                        <b-form-invalid-feedback :state="textValidation">
                            {{ text.positiveAmountValidationMessage }}
                        </b-form-invalid-feedback>
                        <b-form-invalid-feedback :state="showRequiredAmount">
                            {{ text.requiredAmountValidationMessage }}
                        </b-form-invalid-feedback>
                    </div>
                    <div style="padding-left:0px" class="col-md-1 col-2">
                        <info-tooltip :id="'hospitalization'" :htmlText="text.hospitalRoomInfo"></info-tooltip>
                    </div>
                </div>
            </div>
            <div class="separation col-md-6">
                <br class="d-md-none">
                <results></results>
            </div>
        </div>
        <actions @resetForm="resetForm">
        </actions>
        <br>
        <mentions>
            <span slot="title" v-html="text.hospitalization"></span>
            <span v-html="text.hospitalizationMentions"></span>
        </mentions>
    </b-form>
</template>

<script>
import resources from '../helpers/resources'
import validationHelper from '../helpers/validation'
import  { simulationTypes, hospitalizationTypes }  from "../helpers/types"

const HospitalizationVue = {
    data(){
        return {
            text : resources,
            subactTypes:[hospitalizationTypes.hospitalRoom.value, 
                hospitalizationTypes.hospitalRoomForPregnancy.value,
                hospitalizationTypes.accompagnyingBed.value],
            selectedSubAct:null,
            amount:null,
            showRequiredAmount:null,
            showRequiredSubact:null
        }
    },
    methods:{
        resetForm:function (){
            this.amount = null
        },
        CalculateSimulation:function(){
            this.showRequiredAmount = null
            this.showRequiredSubact = null
            if(validationHelper.IsAmountNotEmpty(this.amount) && !validationHelper.IsNaNorNegative(this.amount) && this.selectedSubAct !== null)
                this.$store.dispatch('simulateRefund', { simulationType: simulationTypes.hospitalization.code, specificData: this.TransformAndGetData() })
            if(!validationHelper.IsAmountNotEmpty(this.amount))
                this.showRequiredAmount = false
            if (this.selectedSubAct === null)
                this.showRequiredSubact = false
        },
        TransformAndGetData:function () {
            return {
                hospitalizationType:this.selectedSubAct != null ?
                    hospitalizationTypes.getCode(this.selectedSubAct) : null,
                amount:this.amount
            }
        },
    },
    computed:{
        showResults() { return this.$store.getters.showResults },
        textValidation() { 
            return !validationHelper.IsNaNorNegative(this.amount)
        },
        inputValidation() {
            return validationHelper.IsAPositiveAmountAndNotRequired(this.amount)
        }
    },
    beforeRouteLeave (to, from, next) {
        this.$store.dispatch('backToSimulation')
        next()
    }
}

export default HospitalizationVue;
</script>



// WEBPACK FOOTER //
// src/components/Hospitalization.vue